var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPostureResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#66B6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8906 15.9375C27.8906 15.5492 27.5758 15.2344 27.1875 15.2344C26.7992 15.2344 26.4844 15.5492 26.4844 15.9375V17.7344H21.5625C20.1386 17.7344 18.9844 18.8886 18.9844 20.3125V40.3125C18.9844 41.7364 20.1386 42.8906 21.5625 42.8906H37.8125C39.2364 42.8906 40.3906 41.7364 40.3906 40.3125V20.3125C40.3906 18.8886 39.2364 17.7344 37.8125 17.7344H32.8125C32.4242 17.7344 32.1094 18.0492 32.1094 18.4375C32.1094 18.8258 32.4242 19.1406 32.8125 19.1406H37.8125C38.4597 19.1406 38.9844 19.6653 38.9844 20.3125V40.3125C38.9844 40.9597 38.4597 41.4844 37.8125 41.4844H21.5625C20.9153 41.4844 20.3906 40.9597 20.3906 40.3125V20.3125C20.3906 19.6653 20.9153 19.1406 21.5625 19.1406H26.4844V20.9375C26.4844 21.3258 26.7992 21.6406 27.1875 21.6406C27.5758 21.6406 27.8906 21.3258 27.8906 20.9375V15.9375ZM24.6881 26.4844C24.2998 26.4844 23.985 26.7992 23.985 27.1875C23.985 27.5759 24.2998 27.8907 24.6881 27.8907H27.1881C27.5764 27.8907 27.8912 27.5759 27.8912 27.1875C27.8912 26.7992 27.5764 26.4844 27.1881 26.4844H24.6881ZM24.6881 31.4844C24.2998 31.4844 23.985 31.7992 23.985 32.1875C23.985 32.5758 24.2998 32.8906 24.6881 32.8906L34.6881 32.8906C35.0764 32.8906 35.3912 32.5758 35.3912 32.1875C35.3912 31.7992 35.0764 31.4844 34.6881 31.4844L24.6881 31.4844ZM23.985 37.1875C23.985 36.7992 24.2998 36.4844 24.6881 36.4844H29.6881C30.0764 36.4844 30.3912 36.7992 30.3912 37.1875C30.3912 37.5758 30.0764 37.8906 29.6881 37.8906H24.6881C24.2998 37.8906 23.985 37.5758 23.985 37.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPostureResult);
export default __webpack_public_path__ + "static/media/Icon_Posture_Result.3e77f30e72e740bc094cd1ae0cc25ce8.svg";
export { ForwardRef as ReactComponent };